var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page', [_c('div', {
    staticClass: "sb-container"
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "bottom-end",
      "content": _vm.tooltipContent
    }
  }, [_c('search-box', {
    attrs: {
      "placeholder": _vm.sbPlaceholder,
      "input": _vm.input,
      "onSearch": _vm.onSearch
    }
  })], 1), _vm.showBackButton ? _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("back")]) : _vm._e()], 1), _c('div', {
    staticClass: "results-container"
  }, [_vm.results ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.csResults,
      expression: "loading.csResults"
    }]
  }, [_c('results', {
    attrs: {
      "data": _vm.results || {}
    }
  })], 1) : _c('div', [_c('router-view')], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }